module.exports = __webpack_public_path__ + "img/logo_wwt.8de238a7.png";